import {
  PARTNER_AGENT_COOKIE_NAME,
  PARTNER_ATTRIBUTION_WINDOW_DAYS_DEFAULT,
} from "@/lib/partners/constants"

const COOKIE_MAX_AGE_SECONDS = PARTNER_ATTRIBUTION_WINDOW_DAYS_DEFAULT * 24 * 60 * 60

const CODE_PATTERN = /^[A-Za-z0-9]{6,16}$/

export function normalizePartnerAgentCode(raw: string | null | undefined): string | null {
  if (!raw) return null
  const code = raw.trim().toUpperCase()
  if (!CODE_PATTERN.test(code)) return null
  return code
}

export function readPartnerAgentCodeFromDocumentCookie(
  cookieHeader: string,
  name = PARTNER_AGENT_COOKIE_NAME,
): string | null {
  if (!cookieHeader?.trim()) return null
  const prefix = `${name}=`
  for (const part of cookieHeader.split("; ")) {
    if (!part.startsWith(prefix)) continue
    try {
      const raw = decodeURIComponent(part.slice(prefix.length)).trim()
      return normalizePartnerAgentCode(raw)
    } catch {
      return null
    }
  }
  return null
}

export function buildPartnerAgentCodeSetCookieValue(
  code: string,
  isSecure: boolean,
  maxAgeSeconds: number = COOKIE_MAX_AGE_SECONDS,
): string {
  const safe = code.trim().toUpperCase()
  return `${PARTNER_AGENT_COOKIE_NAME}=${encodeURIComponent(safe)}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax${isSecure ? "; Secure" : ""}`
}
